import Vue from 'vue'
import Router from 'vue-router'
import account from './account'
import playground from './playground'
import personal from './personal/index'
import personalSetting from './personal/setting'
import personalSpread from './personal/spread.js'
import personalHall from './personal/hall.js'
import help from './help'
import hall from './hall'
import payment from './payment'

Vue.use(Router)

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export const constantRoutes = [
  ...account,
  ...playground,
  ...personal,
  ...personalSetting,
  ...personalSpread,
  ...personalHall,
  ...help,
  ...hall,
  ...payment,
  {
    path: '/',
    component: () => import('@/views/Home/Index'),
    name: 'Home',
    meta: {
      title: '首页',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/Memorial',
    component: () => import('@/views/Memorial/Index'),
    name: 'Memorial',
    meta: {
      title: '我的祭祀',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/Sacrifice',
    component: () => import('@/views/Sacrifice/Index'),
    name: 'SacrificeList',
    meta: {
      title: '祭祀列表',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/test',
    component: () => import('@/views/Playground/test'),
    name: 'test',
    meta: {
      title: '测试',
      noCache: true,
      affix: true
    }
  },

  {
    path: '*',
    component: () => import('@/views/Home/404')
  }
]

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

router.beforeEach((to, from, next) => {
  if (!to.meta.requireAuth || (to.meta.requireAuth && localStorage.jwtToken)) {
    next()
  } else {
    next({ path: '/Account/login', query: { nextUrl: to.fullPath } }) // 跳到登录页面
  }
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
